import type { LDContext, LDMultiKindContext } from '../types/types';

/**
 * Check if a context is a multi-kind context.
 * @param context - The context to check.
 * @returns true if it is a multi-kind context.
 */
export function isMultiKind(context: LDContext): context is LDMultiKindContext {
  if ('kind' in context) {
    return context.kind === 'multi';
  }
  return false;
}
